import { path_query } from "@/config/constants/step-paths";
describe("path_query config", () => {
  it("configuracion exportada por defecto", () => {
    expect(path_query).toBeDefined();
    expect(path_query).not.toBeNull();

    expect(path_query).toHaveProperty("APROBADO");
    expect(path_query.APROBADO).toBe("oferta");
  });
});
